import { EMPTY_OBJECT } from '../../../constants/common'
import { getItemsFromApiResponse } from '../../../utils/api'
import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { getUserInfoStatuses } from '../User.api'

import { toUserInfoStatusSelectItems } from './UserInfoStatusSelect.utils'

function UserInfoStatusSelect({
  Control = InputSelectControl,
  apiParams = EMPTY_OBJECT,
  getData = getUserInfoStatuses,
  getDataItems = getItemsFromApiResponse,
  toPreparedItems = toUserInfoStatusSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      apiParams={apiParams}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default UserInfoStatusSelect
